import type { ComponentProps } from "react"
import { useId } from "react"
import { Checkbox, Field, FieldContent, FieldLabel } from "../ui"
import FieldDescriptionOrError from "./FieldDescriptionOrError"

type Props = Omit<ComponentProps<typeof Checkbox>, "className"> &
  Pick<ComponentProps<typeof Field>, "className"> & {
    label: string
    helperText?: string
    error?: string
  }

export default function CheckboxField({
  name,
  label,
  helperText,
  error,
  className,
  ...props
}: Props) {
  // `name` is for form submission and most callers have none; the label still
  // has to point at the control, so fall back to a generated id.
  const generatedId = useId()
  const id = name ?? generatedId

  return (
    <Field orientation="horizontal" className={className}>
      <Checkbox id={id} name={name} {...props} />
      <FieldContent>
        <FieldLabel htmlFor={id}>{label}</FieldLabel>
        <FieldDescriptionOrError description={helperText} error={error} />
      </FieldContent>
    </Field>
  )
}
